import React, { useState, useContext, useEffect } from 'react';
import { Card, Tabs, Tab } from 'react-bootstrap';
import { ProductContext } from '../../../ProductProvider';
import { Helmet } from 'react-helmet-async';
import IssueBooks from '../IssueBooks';
import ReturnBooks from '../ReturnBooks';
import './IssueReturn.css';

export default function IssueReturnView() {
  const { validateLogin, loggedUser } = useContext(ProductContext);
  const [activeTab, setActiveTab] = useState('issue');

  useEffect(() => {
    if (!loggedUser.isAuthenticated) {
      validateLogin();
    }
  }, [loggedUser]);

  return (
    <div className="circulation-portal">
      <Helmet>
        <title>Circulation Desk - Issue & Return | Flynn - Meagher Library</title>
        <meta
          name="description"
          content="Library Circulation Desk for issuing, returning, renewing books and managing borrower loans."
        />
      </Helmet>

      <div className="container-fluid px-md-4">
        {/* Header Card */}
        <div className="circulation-header-card d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div>
            <h3 className="circulation-title">
              <i className="bi bi-arrow-left-right text-primary me-2"></i>
              Circulation Desk
            </h3>
            <p className="circulation-subtitle">
              Manage book checkouts, returns, renewals, and overdue fines for students and faculty.
            </p>
          </div>

          {/* Tab Switcher */}
          <div className="circulation-tabs">
            <Tabs
              id="issue-return-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="border-0"
              mountOnEnter
              unmountOnExit={false}
            >
              <Tab
                eventKey="issue"
                title={
                  <span>
                    <i className="bi bi-box-arrow-up-right me-1"></i> Issue Books
                  </span>
                }
              />
              <Tab
                eventKey="return"
                title={
                  <span>
                    <i className="bi bi-arrow-counterclockwise me-1"></i> Return & Renew
                  </span>
                }
              />
            </Tabs>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'issue' ? (
            <IssueBooks />
          ) : (
            <ReturnBooks />
          )}
        </div>
      </div>
    </div>
  );
}
